import { useState, useMemo, useCallback, useEffect } from "react";

export const SettingLanguages = {
  English: "English",
  Spanish: "Spanish",
};